(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .directive('grouppracticeTable', GroupPracticeTableFn);

    /* protocol category table directive */
    GroupPracticeTableFn.$inject = [];

    function GroupPracticeTableFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/grouppractice/templates/grouppractice-table.template.html',
            controller: 'GroupPracticeTableController',
            controllerAs: 'vm',
            bindToController: true           
        };
        return directive;
    }

})();